const CH_TO_KW = 0.73549875;

/**
 * Convertit une puissance exprimée en chevaux (ch) en kilowatts (kW), arrondie à l'entier.
 * Retourne null si la valeur est vide ou non numérique.
 *
 * @param {number|string|null} horsepower
 * @returns {number|null}
 */
export function chToKw(horsepower) {
    if (horsepower === null || horsepower === undefined || horsepower === '') {
        return null;
    }

    const value = Number(horsepower);

    if (Number.isNaN(value)) {
        return null;
    }

    return Math.round(value * CH_TO_KW);
}
